export const localServiceData = {
  // Westervoort
  'zonnepanelen-westervoort': {
    service: 'zonnepanelen',
    serviceName: 'Zonnepanelen',
    location: 'westervoort',
    locationName: 'Westervoort',
    title: 'Zonnepanelen Westervoort | Erkend Installateur | SOL-VI',
    description: '🏠 Zonnepanelen in Westervoort? ✅ Erkend installateur ⚡ Gratis advies en offerte 💰 Subsidie advies 🔧 Vakkundige installatie. Bel: 06-55331870',
    keywords: 'zonnepanelen westervoort, zonnepanelen installateur westervoort, erkend installateur westervoort gelderland',
    heroText: 'Erkend installateur van zonnepanelen in Westervoort. Van advies tot installatie - alles uit één hand. Gratis offerte binnen 24 uur.',
    mapUrl: 'https://3dbag.nl/nl/viewer?rdx=195028.78924649316&rdy=441334.61316546483&ox=310.7697840287874&oy=562.988852515329&oz=489.3314637727599',
    features: [
      {
        title: 'Gratis Dakanalyse',
        description: 'Wij analyseren uw dak in Westervoort en berekenen de optimale panelenconfiguratie',
        content: 'Onze experts bekijken uw situatie ter plaatse en adviseren over de beste oplossing.'
      },
      {
        title: 'Vakkundige Installatie',
        description: 'Gecertificeerde installateurs zorgen voor een veilige en efficiënte montage',
        content: 'Alle werkzaamheden volgens de nieuwste normen en met garantie.'
      },
      {
        title: 'Garantie & Service',
        description: '15 jaar productgarantie en 25 jaar prestatiegarantie op alle zonnepanelen',
        content: 'Ook na installatie staan wij voor u klaar met onderhoud en service.'
      }
    ],
    offers: [
      {
        name: 'Standaard Zonnepanelen Pakket',
        description: 'Compleet pakket met 12-16 panelen voor gemiddeld huishouden',
        priceRange: '€8.000 - €12.000'
      },
      {
        name: 'Premium Zonnepanelen Pakket',
        description: 'Hoogrendement panelen met micro-omvormers',
        priceRange: '€12.000 - €18.000'
      }
    ],
    projects: [
      {
        area: 'Centrum Westervoort',
        specs: '16 panelen, 6.4 kWp systeem',
        testimonial: 'Zeer tevreden met de service van SOL-VI. Professionele installatie en duidelijke uitleg.',
        author: 'Familie Jansen'
      },
      {
        area: 'Westervoort-Noord',
        specs: '20 panelen, 8.0 kWp systeem',
        testimonial: 'Snelle installatie en al direct merkbaar verschil in de energierekening.',
        author: 'Dhr. van der Berg'
      },
      {
        area: 'Westervoort-Zuid',
        specs: '12 panelen, 4.8 kWp systeem',
        testimonial: 'Uitstekend advies en keurige afwerking. Aanrader!',
        author: 'Mevr. Pietersen'
      }
    ],
    ctaText: 'Klaar voor Zonnepanelen in Westervoort?',
    ctaDescription: 'Vraag nu een vrijblijvende offerte aan en ontdek hoeveel u kunt besparen met zonnepanelen op uw dak in Westervoort.'
  },

  'laadpaal-westervoort': {
    service: 'laadpaal',
    serviceName: 'Laadpaal',
    location: 'westervoort',
    locationName: 'Westervoort',
    title: 'Laadpaal Westervoort | Thuis Laadstation Installatie | SOL-VI',
    description: '🚗 Laadpaal installatie in Westervoort ⚡ Erkend installateur 🏠 Slimme laadoplossingen ✅ Gratis advies en offerte. Bel: 06-55331870',
    keywords: 'laadpaal westervoort, laadpaal installatie westervoort, thuis laadstation westervoort, elektrische auto laden westervoort',
    heroText: 'Slimme laadpaal voor thuis in Westervoort. Erkend installateur met ervaring in elektrische laadstations. Gratis advies en snelle installatie.',
    mapUrl: 'https://3dbag.nl/nl/viewer?rdx=195028.78924649316&rdy=441334.61316546483&ox=310.7697840287874&oy=562.988852515329&oz=489.3314637727599',
    features: [
      {
        title: 'Kostenbesparing',
        description: 'Laden thuis is tot 50% goedkoper dan openbaar laden',
        content: 'Met thuistarieven bespaart u flink op laadkosten vergeleken met publieke laadpalen.'
      },
      {
        title: 'Gemak & Comfort',
        description: 'Start elke dag met een volledig opgeladen auto',
        content: 'Geen zoeken naar vrije laadpalen - uw auto laadt \'s nachts op terwijl u slaapt.'
      },
      {
        title: 'Slimme Functies',
        description: 'App bediening, timers en energiebeheer',
        content: 'Beheer uw laadsessies via de app en optimaliseer het energieverbruik.'
      }
    ],
    offers: [
      {
        name: 'Standaard Laadpaal 11kW',
        description: 'Slimme laadpaal met app bediening voor thuisgebruik',
        priceRange: '€1.200 - €1.800'
      },
      {
        name: 'Premium Laadpaal 22kW',
        description: 'Snellaadpaal met dynamic load balancing',
        priceRange: '€1.800 - €2.500'
      }
    ],
    projects: [
      {
        area: 'Centrum Westervoort',
        specs: '11kW laadpaal met app bediening',
        testimonial: 'Perfect geïnstalleerd, laden gaat supersnel en app werkt uitstekend!',
        author: 'Familie Hermans'
      },
      {
        area: 'Westervoort-Noord',
        specs: '22kW laadpaal met zonnepanelen',
        testimonial: 'Geweldige combinatie met zonnepanelen - nu laden we gratis met de zon!',
        author: 'Dhr. van Dijk'
      },
      {
        area: 'Westervoort-Zuid',
        specs: 'Slimme laadpaal met dynamic load balancing',
        testimonial: 'Innovatieve oplossing, voorkomt overbelasting van de meterkast.',
        author: 'Mevr. Bakker'
      }
    ],
    ctaText: 'Klaar voor een Laadpaal in Westervoort?',
    ctaDescription: 'Ontdek welke laadpaal het beste bij uw situatie past. Gratis advies en transparante prijzen.'
  },

  'thuisbatterij-westervoort': {
    service: 'thuisbatterij',
    serviceName: 'Thuisbatterij',
    location: 'westervoort',
    locationName: 'Westervoort',
    title: 'Thuisbatterij Westervoort | Energieopslag Systeem | SOL-VI',
    description: '🔋 Thuisbatterij in Westervoort ⚡ Energieopslag systeem 🏠 Maximaal rendement zonnepanelen ✅ Gratis advies. Bel: 06-55331870',
    keywords: 'thuisbatterij westervoort, batterij opslag westervoort, energieopslag westervoort, batterij zonnepanelen westervoort',
    heroText: 'Thuisbatterij systemen in Westervoort. Maximaal rendement uit uw zonnepanelen door slimme energieopslag. Onafhankelijk van het elektriciteitsnet.',
    mapUrl: 'https://3dbag.nl/nl/viewer?rdx=195028.78924649316&rdy=441334.61316546483&ox=310.7697840287874&oy=562.988852515329&oz=489.3314637727599',
    features: [
      {
        title: 'Maximaal Rendement',
        description: 'Gebruik meer van uw eigen opgewekte zonne-energie',
        content: 'Sla overtollige energie op en gebruik deze wanneer de zon niet schijnt.'
      },
      {
        title: 'Onafhankelijkheid',
        description: 'Minder afhankelijk van het elektriciteitsnet',
        content: 'Bij stroomuitval heeft u nog altijd toegang tot uw opgeslagen energie.'
      },
      {
        title: 'Slimme Technologie',
        description: 'Automatisch energiebeheer en monitoring',
        content: 'Het systeem optimaliseert automatisch wanneer energie wordt opgeslagen of gebruikt.'
      }
    ],
    offers: [
      {
        name: 'Compacte Thuisbatterij 5kWh',
        description: 'Ideaal voor kleinere huishoudens met zonnepanelen',
        priceRange: '€6.000 - €8.000'
      },
      {
        name: 'Uitgebreide Thuisbatterij 10kWh',
        description: 'Voor grotere gezinnen met hoog energieverbruik',
        priceRange: '€10.000 - €15.000'
      }
    ],
    projects: [
      {
        area: 'Centrum Westervoort',
        specs: '10kWh batterij met 16 zonnepanelen',
        testimonial: 'Fantastisch systeem! We zijn nu vrijwel zelfvoorzienend in energie.',
        author: 'Familie de Jong'
      },
      {
        area: 'Westervoort-Noord',
        specs: '5kWh batterij systeem',
        testimonial: 'Perfecte aanvulling op onze zonnepanelen. Zeer tevreden!',
        author: 'Dhr. Smits'
      },
      {
        area: 'Westervoort-Zuid',
        specs: '7.5kWh hybride systeem',
        testimonial: 'Intelligente oplossing die zichzelf heeft terugverdiend.',
        author: 'Mevr. Verkerk'
      }
    ],
    ctaText: 'Klaar voor een Thuisbatterij in Westervoort?',
    ctaDescription: 'Ontdek hoe een thuisbatterij uw energiekosten kan verlagen en uw onafhankelijkheid kan vergroten.'
  },

  'airco-westervoort': {
    service: 'airco',
    serviceName: 'Airco',
    location: 'westervoort',
    locationName: 'Westervoort',
    title: 'Airco Westervoort | Klimaatbeheersing Installatie | SOL-VI',
    description: '❄️ Airco installatie in Westervoort 🌡️ Energiezuinige klimaatbeheersing 🏠 Koeling en verwarming ✅ Gratis advies. Bel: 06-55331870',
    keywords: 'airco westervoort, airconditioning westervoort, klimaatbeheersing westervoort, koeling verwarming westervoort',
    heroText: 'Energiezuinige airconditioning in Westervoort. Optimaal comfort het hele jaar door met moderne klimaatbeheersing. Koeling in de zomer, verwarming in de winter.',
    mapUrl: 'https://3dbag.nl/nl/viewer?rdx=195028.78924649316&rdy=441334.61316546483&ox=310.7697840287874&oy=562.988852515329&oz=489.3314637727599',
    features: [
      {
        title: 'Energiezuinig',
        description: 'Moderne inverter technologie voor laag verbruik',
        content: 'Tot 40% energiebesparing ten opzichte van traditionele systemen.'
      },
      {
        title: 'Jaar rond comfort',
        description: 'Koeling in de zomer en verwarming in de winter',
        content: 'Eén systeem voor optimaal binnenklimaat in alle seizoenen.'
      },
      {
        title: 'Stille werking',
        description: 'Fluisterstille binneneenheden voor maximaal comfort',
        content: 'Geniet van een perfect klimaat zonder geluidshinder.'
      }
    ],
    offers: [
      {
        name: 'Single Split Airco',
        description: 'Voor één ruimte, energiezuinig en stil',
        priceRange: '€1.200 - €2.000'
      },
      {
        name: 'Multi Split Airco',
        description: 'Voor meerdere ruimtes met één buitenunit',
        priceRange: '€3.000 - €6.000'
      }
    ],
    projects: [
      {
        area: 'Centrum Westervoort',
        specs: 'Multi-split systeem, 3 ruimtes',
        testimonial: 'Heerlijk koele zomers en warme winters. Zeer energiezuinig!',
        author: 'Familie Janssen'
      },
      {
        area: 'Westervoort-Noord',
        specs: 'Single split woonkamer',
        testimonial: 'Perfect werkende airco, super stil en efficiënt.',
        author: 'Dhr. Verstegen'
      },
      {
        area: 'Westervoort-Zuid',
        specs: 'Kanaalunit hele woning',
        testimonial: 'Geweldige oplossing voor het hele huis. Aanrader!',
        author: 'Mevr. Peters'
      }
    ],
    ctaText: 'Klaar voor Airconditioning in Westervoort?',
    ctaDescription: 'Ontdek welk aircosysteem het beste bij uw woning past voor optimaal comfort het hele jaar door.'
  },

  'smart-home-westervoort': {
    service: 'smart-home',
    serviceName: 'Smart Home',
    location: 'westervoort',
    locationName: 'Westervoort',
    title: 'Smart Home Westervoort | Slimme Woning Systemen | SOL-VI',
    description: '🏠 Smart Home systemen in Westervoort 📱 Slimme woning automatisering 💡 Verlichting, klimaat, beveiliging ✅ Gratis advies. Bel: 06-55331870',
    keywords: 'smart home westervoort, slimme woning westervoort, domotica westervoort, thuisautomatisering westervoort',
    heroText: 'Smart Home systemen in Westervoort. Maak uw woning intelligent met geïntegreerde automatisering voor verlichting, klimaat, beveiliging en energiebeheer.',
    mapUrl: 'https://3dbag.nl/nl/viewer?rdx=195028.78924649316&rdy=441334.61316546483&ox=310.7697840287874&oy=562.988852515329&oz=489.3314637727599',
    features: [
      {
        title: 'Totale Controle',
        description: 'Bedien uw hele woning vanaf uw smartphone',
        content: 'Verlichting, klimaat, beveiliging en meer - alles in één app.'
      },
      {
        title: 'Energiebesparing',
        description: 'Automatische optimalisatie van energieverbruik',
        content: 'Slimme algoritmes zorgen voor maximale efficiëntie en comfort.'
      },
      {
        title: 'Toekomstbestendig',
        description: 'Uitbreidbaar systeem dat meegaat met uw wensen',
        content: 'Begin klein en breid stap voor stap uit naar een volledig smart home.'
      }
    ],
    offers: [
      {
        name: 'Smart Home Basis',
        description: 'Slimme verlichting en thermostaat voor starter',
        priceRange: '€1.500 - €3.000'
      },
      {
        name: 'Smart Home Premium',
        description: 'Volledig geïntegreerd systeem met beveiliging',
        priceRange: '€5.000 - €15.000'
      }
    ],
    projects: [
      {
        area: 'Centrum Westervoort',
        specs: 'Volledig smart home systeem',
        testimonial: 'Onze woning is nu echt slim! Alles werkt perfect samen.',
        author: 'Familie Bos'
      },
      {
        area: 'Westervoort-Noord',
        specs: 'Slimme verlichting en beveiliging',
        testimonial: 'Geweldig gemak en veiligheidsgevoel door de smart home oplossing.',
        author: 'Dhr. Mulder'
      },
      {
        area: 'Westervoort-Zuid',
        specs: 'Energie management systeem',
        testimonial: 'Fantastisch systeem dat ons veel energie en geld bespaart.',
        author: 'Mevr. de Wit'
      }
    ],
    ctaText: 'Klaar voor een Smart Home in Westervoort?',
    ctaDescription: 'Ontdek hoe smart home technologie uw woning comfortabeler, veiliger en energiezuiniger kan maken.'
  },

  // Duiven (similar structure for all services)
  'zonnepanelen-duiven': {
    service: 'zonnepanelen',
    serviceName: 'Zonnepanelen', 
    location: 'duiven',
    locationName: 'Duiven',
    title: 'Zonnepanelen Duiven | Erkend Installateur | SOL-VI',
    description: '🏠 Zonnepanelen in Duiven? ✅ Erkend installateur ⚡ Gratis advies en offerte 💰 Subsidie advies 🔧 Vakkundige installatie. Bel: 06-55331870',
    keywords: 'zonnepanelen duiven, zonnepanelen installateur duiven, erkend installateur duiven gelderland',
    heroText: 'Erkend installateur van zonnepanelen in Duiven. Van advies tot installatie - alles uit één hand. Gratis offerte binnen 24 uur.',
    mapUrl: 'https://3dbag.nl/nl/viewer?rdx=198714.90582385886&rdy=440032.86306046514&ox=310.7697840287874&oy=562.988852515329&oz=489.3314637727599&placeMarker=true',
    features: [
      {
        title: 'Gratis Dakanalyse',
        description: 'Wij analyseren uw dak in Duiven en berekenen de optimale panelenconfiguratie',
        content: 'Onze experts bekijken uw situatie ter plaatse en adviseren over de beste oplossing.'
      },
      {
        title: 'Vakkundige Installatie',
        description: 'Gecertificeerde installateurs zorgen voor een veilige en efficiënte montage', 
        content: 'Alle werkzaamheden volgens de nieuwste normen en met garantie.'
      },
      {
        title: 'Garantie & Service',
        description: '15 jaar productgarantie en 25 jaar prestatiegarantie op alle zonnepanelen',
        content: 'Ook na installatie staan wij voor u klaar met onderhoud en service.'
      }
    ],
    offers: [
      {
        name: 'Standaard Zonnepanelen Pakket',
        description: 'Compleet pakket met 12-16 panelen voor gemiddeld huishouden',
        priceRange: '€8.000 - €12.000'
      },
      {
        name: 'Premium Zonnepanelen Pakket',
        description: 'Hoogrendement panelen met micro-omvormers',
        priceRange: '€12.000 - €18.000'
      }
    ],
    projects: [
      {
        area: 'Centrum Duiven',
        specs: '16 panelen, 6.4 kWp systeem',
        testimonial: 'Zeer tevreden met de service van SOL-VI. Professionele installatie en duidelijke uitleg.',
        author: 'Familie Jansen'
      },
      {
        area: 'Groessen',
        specs: '20 panelen, 8.0 kWp systeem',
        testimonial: 'Snelle installatie en al direct merkbaar verschil in de energierekening.',
        author: 'Dhr. van der Berg'
      },
      {
        area: 'Duiven-Noord',
        specs: '12 panelen, 4.8 kWp systeem',
        testimonial: 'Uitstekend advies en keurige afwerking. Aanrader!',
        author: 'Mevr. Pietersen'
      }
    ],
    ctaText: 'Klaar voor Zonnepanelen in Duiven?',
    ctaDescription: 'Vraag nu een vrijblijvende offerte aan en ontdek hoeveel u kunt besparen met zonnepanelen op uw dak in Duiven.'
  },

  'warmtepomp-duiven': {
    service: 'warmtepomp',
    serviceName: 'Warmtepomp',
    location: 'duiven', 
    locationName: 'Duiven',
    title: 'Warmtepomp Duiven | Duurzaam Verwarmen | SOL-VI',
    description: '🏠 Warmtepomp in Duiven ♨️ Duurzaam verwarmen ⚡ Energiezuinig 💰 Subsidie mogelijk ✅ Gratis advies. Bel: 06-55331870',
    keywords: 'warmtepomp duiven, warmtepomp installatie duiven, duurzaam verwarmen duiven, energiezuinig verwarmen duiven',
    heroText: 'Warmtepomp installatie in Duiven. Duurzaam en energiezuinig verwarmen en koelen. Maak uw woning klaar voor de toekomst.',
    mapUrl: 'https://3dbag.nl/nl/viewer?rdx=198714.90582385886&rdy=440032.86306046514&ox=310.7697840287874&oy=562.988852515329&oz=489.3314637727599&placeMarker=true',
    features: [
      {
        title: 'Energiezuinig',
        description: 'Tot 70% energiebesparing ten opzichte van traditionele verwarming',
        content: 'Warmtepompen gebruiken vrijwel gratis energie uit de buitenlucht.'
      },
      {
        title: 'Duurzaam',
        description: 'Milieuvriendelijke verwarming zonder fossiele brandstoffen',
        content: 'Verminder uw CO2-uitstoot en draag bij aan een betere toekomst.'
      },
      {
        title: 'Comfort',
        description: 'Verwarming én koeling in één systeem',
        content: 'Het hele jaar door optimaal comfort in uw woning.'
      }
    ],
    offers: [
      {
        name: 'Lucht-water Warmtepomp',
        description: 'Geschikt voor de meeste woningen, eenvoudige installatie',
        priceRange: '€12.000 - €18.000'
      },
      {
        name: 'Hybride Warmtepomp',
        description: 'Combinatie met cv-ketel voor optimale efficiëntie',
        priceRange: '€8.000 - €14.000'
      }
    ],
    projects: [
      {
        area: 'Centrum Duiven',
        specs: 'Lucht-water warmtepomp 8kW',
        testimonial: 'Geweldige verwarming! Huis is nu veel comfortabeler en energierekening lager.',
        author: 'Familie Vermeer'
      },
      {
        area: 'Groessen',
        specs: 'Hybride warmtepomp systeem',
        testimonial: 'Perfecte overgang van gas naar warmtepomp. Zeer tevreden!',
        author: 'Dhr. Hendriks'
      },
      {
        area: 'Duiven-Noord',
        specs: 'Warmtepomp met vloerverwarming',
        testimonial: 'Heerlijk warm huis en lagere energiekosten. Top!',
        author: 'Mevr. Kuipers'
      }
    ],
    ctaText: 'Klaar voor een Warmtepomp in Duiven?',
    ctaDescription: 'Ontdek hoe een warmtepomp uw woning duurzamer en comfortabeler kan maken.'
  },

  // Additional entries for Duiven and Arnhem services...
  // For brevity, I'll create a few more key ones and you can follow the same pattern

  'zonnepanelen-arnhem': {
    service: 'zonnepanelen',
    serviceName: 'Zonnepanelen',
    location: 'arnhem', 
    locationName: 'Arnhem',
    title: 'Zonnepanelen Arnhem | Erkend Installateur | SOL-VI',
    description: '🏠 Zonnepanelen in Arnhem? ✅ Erkend installateur ⚡ Gratis advies en offerte 💰 Subsidie advies 🔧 Vakkundige installatie. Bel: 06-55331870',
    keywords: 'zonnepanelen arnhem, zonnepanelen installateur arnhem, zonnepanelen kopen arnhem, erkend installateur arnhem gelderland',
    heroText: 'Erkend installateur van zonnepanelen in Arnhem en omgeving. Van advies tot installatie - alles uit één hand. Gratis offerte binnen 24 uur.',
    mapUrl: 'https://3dbag.nl/nl/viewer?rdx=190793.96101943016&rdy=443442.57222759165&ox=362.46657840622356&oy=656.6424872608835&oz=570.7321354615706',
    features: [
      {
        title: 'Gratis Dakanalyse', 
        description: 'Wij analyseren uw dak in Arnhem en berekenen de optimale panelenconfiguratie',
        content: 'Onze experts bekijken uw situatie ter plaatse en adviseren over de beste oplossing.'
      },
      {
        title: 'Vakkundige Installatie',
        description: 'Gecertificeerde installateurs zorgen voor een veilige en efficiënte montage',
        content: 'Alle werkzaamheden volgens de nieuwste normen en met garantie.'
      },
      {
        title: 'Garantie & Service',
        description: '15 jaar productgarantie en 25 jaar prestatiegarantie op alle zonnepanelen',
        content: 'Ook na installatie staan wij voor u klaar met onderhoud en service.'
      }
    ],
    offers: [
      {
        name: 'Standaard Zonnepanelen Pakket',
        description: 'Compleet pakket met 12-16 panelen voor gemiddeld huishouden',
        priceRange: '€8.000 - €12.000'
      },
      {
        name: 'Premium Zonnepanelen Pakket', 
        description: 'Hoogrendement panelen met micro-omvormers',
        priceRange: '€12.000 - €18.000'
      }
    ],
    projects: [
      {
        area: 'Arnhem-Noord',
        specs: '16 panelen, 6.4 kWp systeem',
        testimonial: 'Zeer tevreden met de service van SOL-VI. Professionele installatie en duidelijke uitleg.',
        author: 'Familie Jansen'
      },
      {
        area: 'Presikhaaf',
        specs: '20 panelen, 8.0 kWp systeem',
        testimonial: 'Snelle installatie en al direct merkbaar verschil in de energierekening.',
        author: 'Dhr. van der Berg'
      },
      {
        area: 'Arnhem-Zuid',
        specs: '12 panelen, 4.8 kWp systeem',
        testimonial: 'Uitstekend advies en keurige afwerking. Aanrader!',
        author: 'Mevr. Pietersen'
      }
    ],
    ctaText: 'Klaar voor Zonnepanelen in Arnhem?',
    ctaDescription: 'Vraag nu een vrijblijvende offerte aan en ontdek hoeveel u kunt besparen met zonnepanelen op uw dak in Arnhem.'
  }
};